// Session-based per-stage increment guard using a session cookie (shared across tabs, cleared on browser exit)
// No personal data stored; cookie only contains a list of keys incremented this session

const COOKIE_NAME = "rl_session_counters_v1";

function readCookie(name) {
  try {
    const parts = (document.cookie || "").split(";").map((s) => s.trim());
    for (const p of parts) {
      if (p.startsWith(name + "=")) {
        return decodeURIComponent(p.slice(name.length + 1));
      }
    }
  } catch {}
  return "";
}

function writeSessionCookie(name, value) {
  try {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax`;
  } catch {}
}

function getKeys() {
  const raw = readCookie(COOKIE_NAME);
  if (!raw) return new Set();
  try {
    const arr = JSON.parse(raw);
    if (Array.isArray(arr)) return new Set(arr);
  } catch {}
  return new Set();
}

function putKeys(set) {
  try {
    writeSessionCookie(COOKIE_NAME, JSON.stringify(Array.from(set)));
  } catch {}
}

export function hasIncrementedThisSession(key) {
  const ks = getKeys();
  return ks.has(key);
}

export function markIncrementedThisSession(key) {
  const ks = getKeys();
  ks.add(key);
  putKeys(ks);
}